import React, { useEffect } from 'react';
import AdminRoles from "../AdminRoles.json";
import Select from "react-select";
import { MdOutlineClose } from "react-icons/md";
import { useSelector } from 'react-redux';

const EditModal = ({ selectedIds, setSelectedIds, handleCustomerView, isOpen, onClose, editData, handleOnChange, handleEditSubmit, selectedAccess, setSelectedAccess, error }) => {
  // let userAccess = JSON.parse(window.sessionStorage.getItem("adminuser"));
  const adminData = useSelector(state => state.users?.adminData);
  const admin_type = adminData?.admin_type || "";
  const accessStr = adminData?.access || "";
  let access = accessStr?.split(",") || [];
  const ids = useSelector(state => state.admin?.ids);
  useEffect(() => {
    if(editData?.id) {
      setSelectedIds(ids || []);
    }
    // Cleanup function to clear the state when the component is unmounted
    return () => {
      setSelectedIds([]);
    };
  }, [editData?.id, ids, setSelectedIds]);

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-[1000px] overflow-hidden overflow-y-auto p-6">

        <div className="flex justify-between items-center mb-4 border-b pb-3">
          <h2 className="text-xl font-semibold text-gray-800">{editData?.id ? "Edit" : "Create"} Role</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-red-500">
            <MdOutlineClose className='w-9 h-9 bg-gray-100 rounded-full p-1' />
          </button>
        </div>

        <div className='grid md:grid-cols-2 grid-cols-1 gap-3'>
          <div className="">
            <label htmlFor="name" className="block text-sm font-medium text-black">
              Name
            </label>
            <input
              type="text"
              id="name"
              name='name'
              value={editData?.name || null}
              onChange={handleOnChange}
              placeholder="Enter your name"
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none"
            />
            {error?.name && <span className='text-sm text-red-500' >{error.name}</span>}
          </div>

          <div className="">
            <label htmlFor="user_name" className="block text-sm font-medium text-black">
              Username
            </label>
            <input
              type="text"
              id="user_name"
              name='user_name'
              value={editData?.user_name || null}
              onChange={handleOnChange}
              placeholder="Username"
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none"
            />
            {error?.user_name && <span className='text-sm text-red-500' >{error.user_name}</span>}
          </div>


          <div className="">
            <label htmlFor="email" className="block text-sm font-medium text-black">
              Email
            </label>
            <input
              type="text"
              id="email"
              name='email'
              value={editData?.email || null}
              onChange={handleOnChange}
              placeholder="Enter email"
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none"
            />
            {error?.email && <span className='text-sm text-red-500'>{error.email}</span>}
          </div>

          <div className="">
            <label htmlFor="phone" className="block text-sm font-medium text-black">
              Phone Number
            </label>
            <input
              type="phone"
              id="phone"
              name='phone'
              value={editData?.phone || null}
              onChange={handleOnChange}
              placeholder="Enter phone"
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none"
            />
            {error?.phone && <span className='text-sm text-red-500'>{error.phone}</span>}
          </div>


          <div className="">
            <label htmlFor="passwd" className="block text-sm font-medium text-black">
              Password
            </label>
            <input
              type="text"
              id="passwd"
              name='passwd'
              value={editData?.passwd || null}
              onChange={handleOnChange}
              placeholder="Enter password"
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none"
            />
            {error?.passwd && <span className='text-sm text-red-500'>{error.passwd}</span>}
          </div>

          <div className="">
            <label htmlFor="confirmPasswd" className="block text-sm font-medium text-black">
              Confirm password
            </label>
            <input
              type="text"
              id="confirmPasswd"
              name='confirmPasswd'
              value={editData?.confirmPasswd || null}
              onChange={handleOnChange}
              placeholder="Confirm password"
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none"
            />
            {error?.confirmPasswd && <span className='text-sm text-red-500'>{error.confirmPasswd}</span>}
          </div>


          <div className="">
            <label htmlFor="admin_type" className="block text-sm font-medium text-black">
              Admin Type
            </label>
            <select id="admin_type"
              name='admin_type' value={editData?.admin_type || null}
              onChange={handleOnChange} className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none">
              <option value={""}>Select Type</option>
              <option value={"admin"}>Admin</option>
              <option value={"sub_admin"}>Sub Admin</option>
              {admin_type==="super_admin" && <option value={"super_admin"}>Super Admin</option>}
            </select>
            {error?.admin_type && <span className='text-sm text-red-500'>{error.admin_type}</span>}
          </div>

          <div className="">
            <label htmlFor="access" className="block text-sm font-medium text-black">
              Access
            </label>
            <Select
              isMulti
              id="access"
              options={AdminRoles.filter(e => access.includes(e.value))}
              name='access' value={selectedAccess || null}
              onChange={setSelectedAccess}
              className="w-full py-1 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none"
            />
            {error?.access && <span className='text-sm text-red-500'>{error.access}</span>}
          </div>
          {accessStr.includes("customer") && <div className="">
            <label htmlFor="customerSelected" className="block text-sm font-medium text-black">
              Select Customer
            </label>
            <button
              id="customerSelected"
              onClick={handleCustomerView}
              placeholder="Confirm password"
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none"
            >{selectedIds.length}Selected</button>
          </div>}

        </div>


        <div className="flex justify-start mt-4">
          <button
            className="px-4 py-2 text-sm font-medium text-white bgbtn rounded-md transition w-56 disable"
            onClick={handleEditSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditModal;